export default __webpack_public_path__ + "static/media/bulb.f3902148.svg";